import React from 'react';
import {
  FormControlLabel,
  Radio,
  Typography,
  RadioGroup,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {ActivityGroup} from '../../../schema-types/ActivityGroup';
import theme, {themeColors} from '../../../theme/Theme';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {SaltusAny} from '../../../utils/SaltusAny';
import {UPDATES} from '../../../shared/UPDATES';

const classes = {
  header: {
    boxShadow: theme.shadows[10],
    backgroundColor: theme.palette.primary.main,
    color: themeColors.white,
  },

  body: {
    backgroundColor: themeColors.white,
    color: themeColors.black,
  },

  icon: {
    color: themeColors.white,
  },
};

export interface TaskListProps {
  activityGroups: ActivityGroup[];
  setActivityGroup: (s: string) => void;
  activityGroup: string;
  subgroupId: string;
  setInstructionsList: (s: string) => void;
  setTaskEntityOption: (s: string) => void;
  activityGroupsLoading: boolean;
  activityGroupsError: SaltusAny;
}

export const TaskList: React.FC<TaskListProps> = ({
  activityGroups,
  setActivityGroup,
  activityGroup,
  subgroupId,
  setInstructionsList,
  setTaskEntityOption,
  activityGroupsLoading,
  activityGroupsError,
}) => {
  const {setFieldValue} = useAutoForm();

  if (activityGroupsLoading) {
    return <div>Loading...</div>;
  }

  if (activityGroupsError) {
    return <div>Sorry, there was an error</div>;
  }
  return (
    <div>
      {activityGroups.map(
        ({id: mainId, formattedName: mainName, activitySubGroups: ag}) => (
          <Accordion
            key={mainId}
            onChange={(ev: React.ChangeEvent<any>) => {
              if (activityGroup === mainName) {
                setActivityGroup('');
              } else {
                setActivityGroup((ev?.target as any)?.textContent);
              }
            }}
            expanded={activityGroup === mainName}
            sx={classes.header}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon
                  onClick={(e) => {
                    if (activityGroup === mainName) {
                      setActivityGroup('');
                    } else {
                      setActivityGroup(mainName || '');
                    }
                    e.stopPropagation();
                  }}
                  sx={classes.icon}
                />
              }
            >
              <Typography variant="h6" color={themeColors.white}>
                {mainName}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={classes.body}>
              <RadioGroup
                value={subgroupId}
                onChange={(ev) => {
                  const t = ev?.target?.value;
                  setFieldValue(UPDATES._1307, 'subgroupId', t, false);
                  activityGroups.forEach((a) => {
                    const selectedTask = a?.activitySubGroups?.find((x) => x?.id === t);
                    if (selectedTask) {
                      setInstructionsList(selectedTask.description!);
                      setTaskEntityOption(selectedTask.requiredEntity!);
                    }
                  });
                }}
              >
                {[...(ag || [])]
                  .sort((a, b) => {
                    return a.name?.localeCompare(b.name || '') || 0;
                  })
                  .map((subgroup) => {
                    if (!subgroup) {
                      return null;
                    }
                    const {id: subId, name: subName} = subgroup;
                    return (
                      <FormControlLabel
                        key={subId}
                        checked={subId === subgroupId}
                        label={subName}
                        value={subId}
                        control={<Radio />}
                      />
                    );
                  })}
              </RadioGroup>
            </AccordionDetails>
          </Accordion>
        )
      )}
    </div>
  );
};

export default TaskList;
